import React from 'react';

import { Card } from '@change/ds-core-ui/next';

import type { LegislativeBody } from '../../shared/types';

import { BodyContent } from './BodyContent';

export const LegislativeBodyCard: React.FC<{
	legislativeBody: LegislativeBody;
}> = ({ legislativeBody }) => {
	return (
		<Card className="bg-fill-inverse-strong p-6 shadow-md">
			<BodyContent legislativeBody={legislativeBody} />
		</Card>
	);
};
